<template>
  <div class="table-responsive mt-5" style="min-height: 450px; padding: 0px;">
    <Loader v-if="loading" />
    <table class="table" style="width: 100%" v-else>
      <thead>
        <tr>
          <th style="width: 5%;"></th>
          <th style="width: 10%;">受信日</th>
          <!-- <th>登録/更新日</th> -->
          <th style="width: 15%;">氏名</th>
          <th style="width: 30%;">スカウト求人</th>
          <!-- <th style="width:30%">職種名</th> -->
          <!-- <th>回答結果</th> -->
          <!-- <th class="text-center" style="width:160px;">
                  <b-dropdown
                    id="ddown-aria"
                    text="回答結果"
                    variant="primary"
                    class="m-2 th-dropdown"
                    @hidden="search"
                    @shown="overflow"
                  >
                    <div>
                      <div
                        class="form-check form-check"
                        v-for="(response, index) in userResponses"
                        v-bind:key="index"
                      >
                        <input
                          type="checkbox"
                          :id="index"
                          :value="response"
                          class="form-check-input"
                          v-model="userResponseModel"
                        />
                        <label class="form-check-label">{{response}}</label>
                      </div>
                    </div>
                  </b-dropdown>
                </th> -->
          <th class="text-center" style="width: 10%;">
            <b-dropdown
              id="response-dropdown"
              text="回答内容"
              variant="primary"
              class="m-2 th-dropdown"
              @hidden="search"
              @shown="overflow"
            >
              <div>
                <div
                  class="form-check form-check"
                  v-for="(response, index) in userResponses"
                  v-bind:key="index"
                >
                  <input
                    type="checkbox"
                    :id="'response-' + index"
                    :value="response"
                    class="form-check-input"
                    v-model="userResponseModel"
                  />
                  <label class="form-check-label">{{ response }}</label>
                </div>
              </div>
            </b-dropdown>
          </th>

          <th style="width: 7%;">履歴書/職歴書</th>
          <!-- <th style="width: 3%;">履歴書</th> -->
          <th style="width: 10%;">対応済み非表示</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ReceivedContactList
          v-for="(item, index) in receivedContacts"
          :index="index"
          :key="item._id"
          :receivedContact="item"
          @hideItem="hideItem"
          :rowNumber="rowNumber(index)"
        />
        <tr v-if="showEmptyMessage">
          <td colspan="100%" class="text-center">
            登録者が見つかりませんでした
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination-area" v-if="totalPages > 0">
      <ContactPaginate
        :total-page="totalPages"
        :callback="changePage"
        :currentPage="page"
      />
    </div>
  </div>
</template>

<script>
import IndividualContactModal from '../IndividualContactModal.vue';
import ReceivedContactList from './ReceivedContactList.vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import apiService from '../../../../service/apiService';
import api from '../../../../config/api';
import StatusBox from './StatusBox.vue';
import ContactPaginate from './ContactPaginate.vue';
import Loader from '../../../utils/Loader.vue';
export default {
  data() {
    return {
      tableData: [], // Initialize with an empty array
      openProfile: null,
      pagination: {},
      page: 1,
      loading: false,
      params: {},
      overflowState: 0,
      showEmptyMessage: false,
      userResponses: [
        '選考応募',
        'カジュアル面談',
        '面接参加',
        '質問',
        '応募見合わせ',
      ],
      userResponseModel: [],
    };
  },
  components: {
    StatusBox,
    IndividualContactModal,
    ReceivedContactList,
    ContactPaginate,
    Loader,
  },
  computed: {
    ...mapGetters({
      receivedContacts: 'getReceivedContacts',
      getHiddenContacts: 'getHiddenContacts',
      showHidden: 'getShowHidden',
      getClientStatus: 'getClientStatus',
      getReceivedStatusModel: 'getReceivedStatusModel',
    }),
    // ...mapState({
    //   showHidden: (state) => state.individual_contact.showHidden
    // }),
    statusModel: {
      get() {
        return this.getReceivedStatusModel;
      },
      set(value) {
        this.setReceivedStatusModel(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      // console.log(pagination.total
      //   ? Math.ceil(pagination.total / pagination.perPage)
      //   : 0);
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
  },
  methods: {
    ...mapActions({ loadReceivedContacts: 'loadReceivedContacts' }),
    ...mapMutations([
      'setReceivedContacts',
      'setHiddenContacts',
      'setStatusModel',
      'setReceivedStatusModel',
    ]),
    overflow() {
      this.overflowState = 1;
    },
    showProfile(item) {
      this.openProfile = item.receiver._id;
    },
    setPage(page) {
      this.page = page;
    },
    rowNumber(index) {
      // console.log(index);
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    changePage(page) {
      this.setPage(page);
    },
    filter() {
      const params = {};
      Object.assign(params, this.params);
      params.status = this.statusModel;
    },
    buildParams(page = null) {
      const params = {};
      if (page) params.page = page;
      params.status = this.statusModel;
      params.user_response = this.userResponseModel;
      if (this.showHidden) params.is_hidden = this.showHidden;
      this.page = params.page;
      return params;
    },
    search() {
      this.loadRepliedMessages(this.buildParams(1));
    },
    async hideItem(item) {
      let hideContact = await apiService.put(
        api.endpoints.TOGGLE_HIDE_MESSAGES(item._id)
      );
      // console.log(hideContact);
      if (hideContact) {
        const hiddenContact = hideContact.data;
        // console.log(hiddenContact);
        if (hiddenContact.isHidden && !this.showHidden) {
          let contacts = this.receivedContacts;
          let index = contacts.findIndex(
            (listItem) => listItem._id === hiddenContact._id
          );
          if (index !== -1) {
            contacts.splice(index, 1);
            this.setReceivedContacts(contacts);
            // const hiddenContacts = [...this.getHiddenContacts, hiddenContact];
            // this.setHiddenContacts(hiddenContacts);
          }
        }
      }
    },
    async loadRepliedMessages(params = {}) {
      try {
        this.loading = true;

        let contacts = await this.loadReceivedContacts(params);
        this.pagination = contacts.data.meta.pagination;

        let receivedContacts = contacts.data.data;
        this.showEmptyMessage = receivedContacts.length === 0;
        this.setReceivedContacts(receivedContacts);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  mounted() {
    this.changeBodyToWhite();
  },
  async created() {
    await this.loadRepliedMessages(this.buildParams(1));
  },
  watch: {
    page: function(currentPage) {
      this.loadRepliedMessages(this.buildParams(currentPage));
    },
    showHidden: function(newVal) {
      // if(newVal) {
      this.loadRepliedMessages(this.buildParams(1));
      // }
    },
  },
};
</script>

<style scoped>
>>> .th-dropdown .btn {
  font-size: 14px !important;
}

table th {
  text-align: center !important;
  font-size: 14px !important;
}
/* table td{
  text-align: center !important;
  font-size: 16px !important;
} */
</style>
